import styled from 'styled-components';

export const PointExpireHistoryContainerStyled = styled.div`
  .run_filter_bar {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 1rem;
    padding: 10px 14px;
    border: 1px solid ${({ theme }) => theme.COLORS.BLUE_1};
    border-radius: 10px;
    background: ${({ theme }) => theme.COLORS.BLUE_5};
    color: ${({ theme }) => theme.COLORS.BLUE_3};
    font-size: ${({ theme }) => theme.FONT.SIZE.S13};
    b {
      word-break: break-all;
    }
    .btn_clear_run {
      margin-left: auto;
      width: 160px;
      flex-shrink: 0;
    }
  }
  .filter_layout {
    margin-bottom: 1rem;
  }
  .table_wrap {
    overflow-x: auto;
  }
  .nowrap {
    white-space: nowrap;
  }
  .expire_value {
    color: #c62828;
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
  }
  .flag_mismatch {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 12px;
    white-space: nowrap;
    background: #fde4e4;
    color: #c62828;
    cursor: help;
  }
  .status_badge {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 10px;
    font-size: 12px;
    white-space: nowrap;
    background: ${({ theme }) => theme.COLORS.GRAY_1};
    color: ${({ theme }) => theme.COLORS.GRAY_2};
  }
  .status_success {
    background: #e3f4e3;
    color: ${({ theme }) => theme.COLORS.GREEN_1};
  }
  .status_fail {
    background: #fde4e4;
    color: #c62828;
  }
  .status_processing {
    background: #fff3dc;
    color: #b26a00;
  }
  .error_text {
    margin-top: 4px;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #c62828;
    font-size: 12px;
  }
`;
